import { ConsignmentStockInUpdatePage } from "@/features/consignment-stockin/pages/ConsignmentStockInUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockin/$id/update")({
	beforeLoad() {
		throw redirect({ to: "/admin/consignment-stockin" });
	},
	component: ConsignmentStockInUpdatePage,
});
